import { 
    UPDATE_CONTEXT_MENU, 
    MenuControllerState, 
    MenuControllerTypes,
    UPDATE_SIDE_MENU,
    UPDATE_KEY,
    ADD_RECENT_ITEM,
    SearchItemType,
    TOGGLE_MAINTENANCE
} from './types';

const initialState : MenuControllerState = {
    contextOpen : false,
    sideMenuOpen : true,
    contextKey : 0,
    // Search Data
    recentItems : [],
    isMaintenance: false
}

export function menuReducer(
    state = initialState, 
    action : MenuControllerTypes): MenuControllerState {
        let recentItemsCopy: any = [...state.recentItems];
        switch(action.type){
            case TOGGLE_MAINTENANCE:
                return {...state, isMaintenance: action.payload};
            case ADD_RECENT_ITEM:
                if(recentItemsCopy.findIndex((item: SearchItemType): boolean => item.url === action.payload.url) === -1){
                    if(recentItemsCopy.length >= 5){
                        recentItemsCopy.shift();
                    }
                    return {...state, recentItems : [...recentItemsCopy, action.payload]};
                }
                return {...state};
            case UPDATE_SIDE_MENU:
                return {...state, sideMenuOpen : action.payload};
            case UPDATE_CONTEXT_MENU:
                return {...state, contextOpen : action.payload};
            case UPDATE_KEY:
                return {...state, contextKey : state.contextKey + 1}; 
            default:
                return {...state}
        }
}
